import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import { AiOutlineInfoCircle } from '@react-icons/all-files/ai/AiOutlineInfoCircle';
import { getReverseStoreMappingPH } from 'spwa-ui-library/esm/utils/helper';

function ChangeOrderMode({ availableModes = [], handleOrderModePopup, productId }) {
  return (
    <div className={css.changeOrderMode}>
      <span className={css.orderModeTitle}>
        <FormattedMessage id={'valid_only_for'} />
      </span>
      <span className={css.orderModeList} onClick={(e) => handleOrderModePopup(productId)}>
        {availableModes.map(getReverseStoreMappingPH).join(' | ')}
        <AiOutlineInfoCircle className={css.infoIcon} />
      </span>
    </div>
  );
}

export default ChangeOrderMode;
